import addEditRecord from 'add_edit_modals'

export default ({ deal, onSuccess, onClose }) => {
  addEditRecord({ resourceType: 'deal', values: deal?.attributes, formMeta: { onSuccess, onClose } })
}
